import { loadToken } from "@src/auth"
import { api } from "@src/config"
import { showErrorToast } from "./errorMessages"
import { putSentryLog } from "./putSentryLog"

type PARAMS_MULTIPART = {
  method: "POST" | "PUT" | "DELETE" | "PATCH"
  path: string
  formData: FormData
  endpointType?: "api" | "ilockit"
  partnerUuid?: string
}

type RESPONSE<T> = {
  response: {
    ok: boolean
    status: number
  }
  data?: T
}

const buildHeadersForMultipart = (partnerUuid: string | null) => {
  const token = loadToken()
  return {
    ...(token && { Authorization: `Token token=${token}` }),
    ...(partnerUuid && { partner_uuid: partnerUuid }),
  }
}

export const callApiMultipart = async <RESPONSE_TYPE>({
  method,
  path,
  formData,
  partnerUuid = null,
}: PARAMS_MULTIPART): Promise<RESPONSE<RESPONSE_TYPE>> =>
  fetch(api.baseUrl + path, {
    method,
    headers: buildHeadersForMultipart(partnerUuid),
    body: formData,
  })
    .then((response) => {
      try {
        return response.json().then((data) => {
          if (!response.ok) {
            const token = loadToken()
            const logObject = {
              method,
              userText: token,
              body: "FormData (multipart)",
              url: api.baseUrl + path,
              status: response.status,
              statusText: response.statusText,
            }
            putSentryLog(logObject)
            showErrorToast(response.status)
          }
          return { response, data }
        })
      } catch (error) {
        console.error("error", api.baseUrl + path, error)
        showErrorToast(500)
        return { response }
      }
    })
    .catch((error) => {
      console.error("error", api.baseUrl + path, error)
      showErrorToast(500)
      return {
        response: {
          ok: false,
          status: 500,
        },
      }
    })
